import PropTypes from "prop-types";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";

import React from "react";
import CampaignBase from "./CampaignBase";
import {Box, Card, CardActionArea, CardActions, CardContent, IconButton} from "@mui/material";
import {MoreVert} from "@mui/icons-material";
import Menu from "../menu/Menu";

class CampaignList extends CampaignBase {

  render() {
    let campaign = this.props.campaign;
    if (this.state.image === null) {
      let campaignImageUrl = campaign.thumbnail !== undefined && campaign.thumbnail !== '' ? campaign.thumbnail :
        this.defaultImages[(this.props.index % 7 + 1)];
      this.state.image = <img alt='Thumbnail'
                              onClick={(e) => this.onStatusMenuClick(e)}
                              src={campaignImageUrl}
                              className={'object-cover border-2 cursor-pointer rounded-tl-none rounded-tr-[8px] rounded-bl-[8px] rounded-br-[8px] ml-[8px]] min-h-[54px] min-w-[54px] ' +
                                this.getColorClassFromStatus(campaign.status, true)}/>;
    }

    let formattedDate = 'undefiniert';
    if (campaign.eventDateTime != null) {
      formattedDate = new Intl.DateTimeFormat('de-CH', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(campaign.eventDateTime);
    }

    return <>
      <Card sx={{
        display: 'flex',
        height: '60px',
        width: '300px',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px'
      }}>
        <CardContent sx={{display: 'flex', padding: 0.4, gap: 1, width: '100%'}}>
          <Box className='w-[65px]'>{this.state.image}</Box>
          <Menu
            open={Boolean(this.state.statusMenuAnchorEl)}
            anchorEl={this.state.statusMenuAnchorEl}
            onClose={() => this.setState({statusMenuAnchorEl: null})}>
            {this.statusMenuItems}
          </Menu>
          <CardActionArea className='truncate' onClick={(e) => this.onCardClick(e)}>
            <VerticalLayout className='justify-center'>
              <h5 className="truncate pl-0.5">{campaign.name}</h5>
              <p className='text-sm text-cn-color-secondary'>{formattedDate}</p>
            </VerticalLayout>
          </CardActionArea>
        </CardContent>
        <CardActions>
          <IconButton size='small' onClick={(e) => this.onMoreButtonClick(e)}>
            <MoreVert/>
          </IconButton>
          <Menu
            open={Boolean(this.state.campaignMoreMenuAnchorEl)}
            anchorEl={this.state.campaignMoreMenuAnchorEl}
            onClose={() => this.setState({campaignMoreMenuAnchorEl: null})}>
            {this.campaignMoreMenuItems}
          </Menu>
        </CardActions>
      </Card>
      {this.createDeleteCampaignDialog()}
      {this.createUpdateCampaignDialog()}
    </>;
  }
}

CampaignList.propTypes = {
  campaign: PropTypes.object, onClick: PropTypes.func, reloadCampaigns: PropTypes.func, index: PropTypes.number
}
export default CampaignList;